export default __webpack_public_path__ + "static/media/staff_icon.f0b0a1c6.png";